import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { State } from '../../models/state';
import { StateService } from '../../services/state.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerState: PageHeader;
  entity: State = new State();
  selectedState: State = new State();
  editingEntity: State = new State();
  states: any;
  stateColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  zone: Array<Zone> = [];
  selectedZone: any;
  opened: boolean = false;
  details: any;

  constructor(
    private _stateService: StateService,
    private _companyService: CompanyService,
    private _zoneService: ZoneService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerState = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.states = [];
    this.getAllState();
  }

    ngAfterViewInit(): void {
    this.stateColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 100 },
      { field: "StateName", title: 'State', filter: true, sortable: true, width: 150 },
      { field: "StateCode", title: 'Code', filter: true, sortable: true, width: 150 },
      { field: "EmployeeName", title: 'State Head', filter: true, sortable: true, width: 150 },
      { field: "StateMail", title: 'Email Id', filter: true, sortable: true, width: 150 },
      { field: "StatePhone", title: 'Phone', filter: true, sortable: true, width: 150 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true },
      { field: "ZoneName", title: 'Zone', filter: true, sortable: true, width: 150 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 150 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._stateService.getAllStates('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<State>) => {
      this.states = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllZone(filter: string) {
    this._zoneService.getAllZones(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Zone>) => {
      this.zone = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._stateService.getAllStates(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((states: Array<State>) => {
        this.states = {
          data: states,
          total: states[0] ? states[0].TotalCount : 0
        }
      });
    }
  }
  getAllState() {
    this._stateService.getAllStates('', Number(this.defaultPageSize), 1, 0, 0).subscribe((states: Array<State>) => {
      this.states = {
        data: states,
        total: states[0] ? states[0].TotalCount : 0
      }
    })
  };
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._stateService.deleteState(this.selectedState.State_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearState();
            this.getAllState();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerState = new PageHeader();
    headerState.PageCaption = "State";
    headerState.IconClass = "bi bi-shield-shaded";
    return headerState;
  }

  deleteState(event: any) {
    if (event.seletedRows[0]) {
      this.selectedState.State_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "State",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addState(event: any) {
    this.listView = false;
    this.clearState();
    this.getAllCompany('');
    this.getAllEmployees('');
    this.getAllZone('');
    this.formCaption = "Add State";
  }

  editState(event: any): void {
    if (event.seletedRows[0]) {
      this._stateService.viewState(event.seletedRows[0]).subscribe((states: Array<State>) => {
        let editEnity = states[0] ? states[0] : new State();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedZone = { Zone_Id: editEnity.Zone_Id, Zone_Name: editEnity.ZoneName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit State";
          this.getAllCompany('');
          this.getAllEmployees('');
          this.getAllZone('');
          this.entity.EntityMetaData = [
            { FieldName: 'StateName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.Code)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._stateService.checkDuplication(this.entity.State_Id,this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('State Code Already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
          }
          else {
            if (this.entity.EmailId != "") {
              // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;commented on 04-06-2024 by jessil for #I238
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
              if (this.emailcheck === false) {
                this.notification.showWarning("Email not valid");
                this.saveDisabled = false;
                return
              }
            }
              // else {
                this._stateService.checkEmail(this.entity.EmailId, this.entity.State_Id).subscribe((response) => {
                  if (response.Success == false) {
                    this.notification.showWarning("Email already exists");
                    this.saveDisabled = false;
                    return
                  }

                  else {
                    this._stateService.saveState(this.entity).subscribe(() => {
                      if (this.entity.State_Id == '00000000-0000-0000-0000-000000000000') {
                        this.notification.showSuccess('Saved Successfully');
                      }
                      else {
                        this.notification.showSuccess('Updated Successfully');
                      }
                      this.listView = true;
                      this.clearState();
                      this.getAllState();
                    });
                  }

                });
                  // else {
                    // this._stateService.saveState(this.entity).subscribe(() => {
                    //   if (this.entity.State_Id == '00000000-0000-0000-0000-000000000000') {
                    //     this.notification.showSuccess('Saved Successfully');
                    //   }
                    //   else {
                    //     this.notification.showSuccess('Updated Successfully');
                    //   }
                    //   this.listView = true;
                    //   this.clearState();
                    //   this.getAllState();
                    // });
                  // }
                
              // }
            // }
          }
        }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllState();
  }
  goToBackTab(): void {
    this.listView=true;
}

  refreshStates(event: any): void {
    this.states = [];
    this.getAllState();
  }

  clearState(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.selectedZone = {};
    this.entity = new State();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.State_Id=dataItem.State_Id;
 this.details =[];
 this._stateService.viewState(this.entity.State_Id).subscribe((states: Array<State>) => {
  this.opened = true;
  this.details = states[0];
  })}

}
